import React from 'react';
import { Button, Header, Responsive, Segment, Tab, Loader } from 'semantic-ui-react';
import axios from 'axios';
import SemesterInfo from './SemesterInfo';
import AddSemesterInfo from './AddSemesterInfo';
import { toast, ToastContainer } from 'react-toastify';
import SemesterCourses from './SemesterCourses';

axios.defaults.xsrfHeaderName = 'X-XSRF-TOKEN';
axios.defaults.xsrfCookieName = 'XSRF-TOKEN';
axios.defaults.withCredentials = true;
// axios.defaults.crossDomain = true;

export default class Semesters extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            semesters: [],
            lookupSemesters: [],
            panes: [],
            edit: false,
            addSemesterMode: false,
            activeIndex: 0,
            loading: true

        };
        this.getSemesters = this.getSemesters.bind(this);
        this.getPanes = this.getPanes.bind(this);
        this.handleTabChange = this.handleTabChange.bind(this);
    }

    componentDidMount() {
        this.getSemesters();

        axios.get('study-program-semesters')
            .then(res => {
                this.setState({
                    lookupSemesters: res.data.map(el => ({
                        ...el, key: el.id, value: el.id, text: el.name
                    })),
                    loading: false
                });
            })
            .catch(err => {
                console.log('Failed to fetch semesters');
            });
    }

    getSemesters() {
        let implementation = JSON.parse(localStorage.getItem('implementation'));
        // eslint-disable-next-line prefer-destructuring
        if (!implementation) implementation = this.props.location.state.implementation;
        axios.get(`study-programs/semesters/${implementation.studyProgram ? implementation.studyProgram.id : implementation.id}`)
            .then(res => {
                this.setState({ semesters: res.data });
                this.getPanes(res.data);
            })
            .catch(err => {
                console.log('Failed to fetch semesters');
            });
    }

    getPanes(semesters) {
        let panes = [];
        semesters.sort((a, b) => a.studyProgramSemester.number - b.studyProgramSemester.number).map(el => {
            panes.push({
                menuItem: `${el.studyProgramSemester.name}`,
                render: () => (<Tab.Pane clearing attached={false} as={Responsive}>
                    <h3>Osnovne informacije o semestru</h3>
                    <SemesterInfo
                        semester={el}
                        activeIndex={this.state.activeIndex}
                        getSemesters={(remove, edit, activeIndex) => {
                            remove ? toast('Uspješno ste obrisali semestar sa implementacije studijskog programa.') : edit ? toast('Uspješno ste izmijenili informacije o semestru!')
                                : null;
                            this.setState({ activeIndex });
                            this.getSemesters();
                        }}
                    />
                    <br /><br /><br /><br />
                    <SemesterCourses
                        semesterId={el.id}
                        sPsemesterId={el.studyProgramSemester.id}
                        semesterNumber={el.studyProgramSemester.number}
                        newSPId={this.props.location.state ? this.props.location.state.implementation.studyProgram.id :
                            JSON.parse(localStorage.getItem('implementation')).studyProgram ? JSON.parse(localStorage.getItem('implementation')).studyProgram.id
                                : JSON.parse(localStorage.getItem('implementation')).id}
                        getSemesters={this.getSemesters}
                        semesters={this.state.semesters}
                    />
                </Tab.Pane>)
            });
        });

        this.setState({ panes });
    }

    handleTabChange(e, { activeIndex }) {
        this.setState({ activeIndex });
        localStorage.setItem('changeSemester', true);
    }


    render() {
        let implementation = JSON.parse(localStorage.getItem('implementation'));
        // eslint-disable-next-line prefer-destructuring
        if (!implementation) implementation = this.props.location.state.implementation;

        return (
            <div>
                <Header as="h1">Prikaz semestara</Header>
                {this.state.addSemesterMode &&
                    <AddSemesterInfo
                        id={implementation.studyProgram ? implementation.studyProgram.id : implementation.id}
                        getSemesters={() => { this.setState({ addSemesterMode: false }); this.getSemesters(); }}
                        closeAddSemesterMode={() => this.setState({ addSemesterMode: false })}
                        lookupSemesters={this.state.lookupSemesters}
                    />
                }
                <Segment.Group raised>
                    <Segment>
                        <Header as="h3">
                            <Header.Content>
                                {localStorage.getItem('basicName')} - {implementation.studyProgram ? implementation.studyProgram.name : implementation.name}

                            </Header.Content>
                            <Header.Subheader>{implementation.studyProgram.description}</Header.Subheader>
                        </Header>
                    </Segment>
                    { this.state.loading ? <Segment style={{ paddingTop: '100px', paddingBottom: '100px' }}><Loader active inline="centered" /></Segment>
                        : <Segment>
                            {(localStorage.getItem('activeRole').substr(0, 30) !== 'Služba za osiguranje kvaliteta' && localStorage.getItem('activeRole').substr(0, 38) !== 'Služba za nastavu i studentska pitanja') && <Button color="blue" floated="right" onClick={() => this.setState({ addSemesterMode: true, activeIndex: 0 })}>Dodavanje novog semestra</Button>}
                            <br /><br />

                            <Tab menu={{ secondary: true, pointing: true, color: 'blue' }} panes={this.state.panes} activeIndex={this.state.activeIndex} onTabChange={this.handleTabChange} />
                        </Segment>}
                </Segment.Group>
                <ToastContainer hideProgressBar />
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./src/views/Admin/CreateStudyProgram/Semesters.js